import {Customer} from '../queries/Customer';
import {Item} from '../queries/Item';
import {useUserInfo} from '../../userInfo/hooks/useUserInfo';

import {useNavigate} from "react-router-dom";

export const useSubmit = () => {
  const {profil} = useUserInfo();
  const navigate = useNavigate();

  const getCustomerId = async profil => {
    console.log('Profil:', profil);
    const response = await Customer.getCustomerByEmail(profil.email);
    let customerId = response.data.customers?.[0]?.id;

    if (!customerId) {
      const customerData = {
        firstname: profil.first_name,
        lastname: profil.last_name,
        email: profil.email,
      };
      const creation = await Customer.createCustomer(customerData);
      if (creation.status === 201) {
        customerId = creation.data.customer.id;
      }
    }
    return customerId;
  };

  const submit = async (values, itemId, paymentId, total) => {
    try {
      console.log('Submit:', values);
      const customerId = await getCustomerId(profil);

      let addressIdInvoice = null;
      let addressIdDelivery = null;
      let addressId = null;
      if (customerId) {
        const address = await Customer.getCustomerAddress(customerId);

        if (address.data.addresses) {
          const addressDelivery = address.data.addresses.filter(item => {
            return item.type === 'delivery';
          });
          const addressInvoice = address.data.addresses.filter(item => {
            return item.type === 'invoice';
          });
          addressIdDelivery = addressDelivery?.[0]?.id;
          addressIdInvoice = addressInvoice?.[0]?.id;
        }

        //address.data.addresses?.[0]?.id;
        console.log('profil', profil);

        if (!addressIdInvoice && profil.address === "") {
          return false;
        }

        if (!addressIdInvoice) {
          const addressData = {
            address1: profil.address,
            city: profil.city,
            id_country: 8,
            id_customer: customerId,
            alias: 'Adresse',
            lastname: profil.last_name,
            firstname: profil.first_name,
            postcode: profil.postalCode,
            type: 'invoice',
          };
          const addressCreation = await Customer.createAddress(addressData);
          if (addressCreation.status === 201) {
            addressIdInvoice = addressCreation.data.address.id;
          }
        }

        let addressValue = '';
        let city = '';
        let postalCode = '';
        if (values.hasOwnProperty('address')) {
          addressValue = values.address.split(';')[0];
          city = values.address.split(';')[1];
          postalCode = values.address.split(';')[2];
        } else {
          addressValue = profil.address;
          city = profil.city;
          postalCode = profil.postalCode;
        }
        const addressData = {
          address1: addressValue,
          city: city,
          id_country: 8,
          id_customer: customerId,
          alias: 'Adresse',
          lastname: profil.last_name,
          firstname: profil.first_name,
          postcode: postalCode,
          type: 'delivery',
        };

        if (!addressIdDelivery) {
          const addressCreation = await Customer.createAddress(addressData);
          if (addressCreation.status === 201) {
            addressIdDelivery = addressCreation.data.address.id;
          }
        } else {
          const addressCreation = await Customer.updateAddress(
            addressData,
            addressIdDelivery,
          );
          if (addressCreation.status === 201) {
            addressIdDelivery = addressCreation.data.address.id;
          }
        }
      }
      console.log('AddressIdDelivery:', addressIdDelivery);
      console.log('AddressIdInvoice:', addressIdInvoice);
      if (customerId && addressIdDelivery && addressIdInvoice) {
        const cartResponse = await Customer.createCart(
          customerId,
          addressIdDelivery,
          itemId,
          addressIdInvoice,
        );
        if (cartResponse.status === 201) {
          const cartId = cartResponse.data.cart.id;

          if (paymentId === 2 || paymentId === 3) {
            const orderResponse = await Customer.createOrder(
              cartId,
              customerId,
              addressIdDelivery,
              addressIdInvoice,
              total,
            );
            if (orderResponse.status === 201) {
              const orderId = orderResponse.data.order.id;
              const formResponse = await Customer.sendForm(
                customerId,
                orderId,
                values,
              );
              console.log('Form response:', formResponse);
              if (formResponse.status === 201) {
                console.log('Order created:', orderResponse);
              }
            }
            const linkResponse = await Customer.getStripeSessionLink(
              cartId,
              paymentId,
            );
            if (linkResponse.status === 200) {
              window.location.href = linkResponse.data.url;
              return true;
            }
          } else if (paymentId === 4) {
            const quoteResponse = await Customer.createQuote(
              itemId,
              customerId,
              values,
            );
            if (quoteResponse.status === 200) {
              console.log('Quote created:', quoteResponse);
              return true;
            }
          } else {
            const orderResponse = await Customer.createOrder(
              cartId,
              customerId,
              addressIdDelivery,
              addressIdInvoice,
              total,
              true,
            );
            if (orderResponse.status === 201) {
              const orderId = orderResponse.data.order.id;
              const formResponse = await Customer.sendForm(
                customerId,
                orderId,
                values,
              );
              console.log('Form response:', formResponse);
              if (formResponse.status === 201) {
                console.log('Order created:', orderResponse);
                return true;
              }
            }
          }
        } else {
          console.log('Error creating cart', cartResponse);
        }
      } else {
        console.log('Error creating');
      }
      return false;
    } catch (error) {
      console.log('Error creating order:', error);
      return false;
    }
  };

  const createOrderFromOld = async oldOrderId => {
    try {
      const oldOrder = await Customer.getOrderById(oldOrderId);
      const formValuesResponse = await Customer.getFormByOrder(oldOrderId);

      let formValues = null;
      if (formValuesResponse.status === 200) {
        formValues = formValuesResponse.data.form_field_values;
      }
      if (oldOrder.status === 200) {
        const oldOrderData = oldOrder.data.orders[0];
        const customerId = oldOrderData.id_customer;
        const addressId = oldOrderData.id_address_delivery;
        const addressInvoiceId = oldOrderData.id_address_invoice;
        const productId = oldOrderData.associations.order_rows[0].product_id;
        console.log('oldOrderData', oldOrderData);
        const product = await Item.getProductSingle(productId, customerId);

        navigate(`/item-detail/${productId}`);
        return false;
        if (customerId && addressId && addressInvoiceId) {
          const cartResponse = await Customer.createCart(
            customerId,
            addressId,
            productId,
            addressInvoiceId
          );
          if (cartResponse.status === 201) {

            const paymentId = product.payment_type;
            const cartId = cartResponse.data.cart.id;
            if (paymentId === 2) {
              const linkResponse = await Customer.getStripeSessionLink(cartId);
              if (linkResponse.status === 200) {
                window.location.href = linkResponse.data.url;
                return true;
              }
            } else if (paymentId === 4) {
              const quoteResponse = await Customer.createQuote(
                productId,
                customerId,
                formValues,
              );
              if (quoteResponse.status === 200) {
                console.log('Quote created:', quoteResponse);
                return true;
              }
            } else {
              const orderResponse = await Customer.createOrder(
                cartId,
                customerId,
                addressId,
                addressInvoiceId,
                oldOrderData.total_paid ?? 0,
              );
              if (orderResponse.status === 201) {
                const orderId = orderResponse.data.order.id;
                const formResponse = await Customer.sendFormFromCreateFromOld(
                  customerId,
                  orderId,
                  formValues,
                );
                console.log('Form response:', formResponse);
                if (formResponse.status === 201) {
                  console.log('Order created:', orderResponse);
                  return orderId;
                }
              }
            }
          } else {
            console.log('Error creating cart', cartResponse);
          }
        } else {
          console.log('Error creating');
        }
      }
    } catch (error) {
      console.log('Error creating order from old order:', error);
    }
    return false;
  };

  const searchProduct = async name => {
    const customerId = await getCustomerId(profil);
    return await Item.searchProductByName(name, customerId, profil.postalCode);
  };

  return {submit, getCustomerId, createOrderFromOld, searchProduct};
};
